import { authedFetch, type SessionState } from './session.js';

/** The user's Google Calendar connection (server: routes/google-calendar.ts). Never a token. */
export interface EstadoCalendario { disponible: boolean; conectado: boolean; cuenta: string | null; fallo: string | null }

const mensaje = (codigo: string | undefined): string => codigo === 'usuario_no_activo'
  ? 'Tu usuario no tiene acceso activo a Meet.'
  : codigo === 'calendario_no_activado' ? 'Google Calendar todavía no está activado en el servidor.'
    : 'No se ha podido actualizar Google Calendar. Vuelve a intentarlo.';

export async function leerCalendario(session: SessionState): Promise<EstadoCalendario> {
  const r = await authedFetch(session, '/api/google-calendar');
  const d = await r.json().catch(() => null);
  if (r.status !== 200 || typeof d?.disponible !== 'boolean') throw new Error(mensaje(d?.error));
  return { disponible: d.disponible, conectado: Boolean(d.conectado), cuenta: typeof d.cuenta === 'string' ? d.cuenta : null, fallo: typeof d.fallo === 'string' ? d.fallo : null };
}

/** Google's screen for this user (it carries a signed state that lasts 10 minutes). */
export async function urlConectarCalendario(session: SessionState): Promise<string> {
  const r = await authedFetch(session, '/api/google-calendar/conectar', { method: 'POST' });
  const d = await r.json().catch(() => null);
  if (r.status !== 200 || typeof d?.url !== 'string' || !d.url.startsWith('https://accounts.google.com/')) throw new Error(mensaje(d?.error));
  return d.url;
}

export async function desconectarCalendario(session: SessionState): Promise<void> {
  const r = await authedFetch(session, '/api/google-calendar', { method: 'DELETE' });
  if (r.status !== 200) throw new Error(mensaje((await r.json().catch(() => null))?.error));
}
